import backend from "../api/api";
import { store } from "../store";
import { message } from "antd";

const getConfig = () => {
  const token = store.getState().auth.token;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  return config;
};

export const createAccountingPeriod = (values) => async (dispatch) => {
  try {
    const response = await backend.post(
      "api/accounting/accounting-periods/",
      values,
      getConfig()
    );
    if (response.status === 201) {
      return response.data;
    }
  } catch (error) {
    message.error("Failed to create period. Make sure the dates are valid.");
    console.error(error.response || error);
    return false;
  }
};

export const closeAccountingPeriod = (id) => async (dispatch) => {
  try {
    const response = await backend.post(
      `api/accounting/accounting-periods/${id}/close/`,
      {},
      getConfig()
    );
    if (response.status === 200) {
      message.success("Period closed successfully!");
      return response.data;
    }
  } catch (error) {
    message.error(
      error.response?.data?.error || "Failed to close the period."
    );
    console.error(error.response || error);
    return false;
  }
};

export const reopenAccountingPeriod = (id) => async (dispatch) => {
  try {
    const response = await backend.post(
      `api/accounting/accounting-periods/${id}/reopen/`,
      {},
      getConfig()
    );
    if (response.status === 200) {
      message.success("Period re-opened successfully!");
      return response.data;
    }
  } catch (error) {
    message.error(
      error.response?.data?.error || "Failed to re-open the period."
    );
    console.error(error.response || error);
    return false;
  }
};

export const getClosingReports = () => async (dispatch) => {
  try {
    const response = await backend.get(
      "api/accounting/closing-reports/",
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error(error.response || error);
    return [];
  }
};

export const getAccountingPeriods = () => async (dispatch) => {
  try {
    const response = await backend.get(
      "api/accounting/accounting-periods/",
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error(error.response || error);
    return [];
  }
};
